module.exports = __webpack_public_path__ + "bdbfa0a08d92001ae4915de5a3dd1707.svg";